import script from "./HotelMeeting.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelMeeting.vue?vue&type=script&setup=true&lang=js"

import "./HotelMeeting.vue?vue&type=style&index=0&id=1397874c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1397874c"]])

export default __exports__